import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import {
  CalendlyEventTypesPanel,
  DerivedManagedEventsPanel,
} from "@/features/supply-config/ui/calendly-panels";
import { Button } from "@/components/ui/button";

export default function ManagedEventCalendly() {
  const navigate = useNavigate();
  return (
    <div className="py-6 space-y-4">
      <div className="px-6 flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={() => navigate("..")}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Managed Events — Calendly data</h1>
      </div>
      <DerivedManagedEventsPanel
        onCreateFromDerived={(prefill) =>
          navigate("../new", { state: { prefill } })
        }
      />
      <CalendlyEventTypesPanel
        adminManaged
        title="Calendly Managed Events"
        subtitle="Admin-managed event types (admin_managed=true) — assign a user group and Calendly fans these out into a per-user event type."
      />
    </div>
  );
}
